import * as React from "react";
import { useParams } from "react-router-dom";
import { FileTranslationMainPage } from "./FileTranslationMainPage/FileTranslationMainPage";
import { MtJobRequestDetailsPage } from "../components/MtJobRequestDetailsPage/MtJobRequestDetailsPage";
import { useNavigation } from "../../../hooks/useNavigation";
import { ROUTES } from "../../../utils/navigationUtils";

const FileTranslationTab: React.FC = () => {
  const { navigateTo } = useNavigation();
  const { jobRequestId } = useParams<{ jobRequestId?: string }>();

  const onReturnFromDetailsClick = React.useCallback(() => navigateTo(ROUTES.MACHINE_TRANSLATION_FILE), [navigateTo]);

  if (jobRequestId) {
    return (
      <MtJobRequestDetailsPage
        jobRequestId={jobRequestId}
        onReturnClick={onReturnFromDetailsClick}
        showAiToolboxFeatures={true}
        isFileSelectionEnabled={true}
        hideReasonOptions={true}
        hideNotes={true}
      />
    );
  }

  return <FileTranslationMainPage />;
};

export { FileTranslationTab };
